import createReactComponent from '../createReactComponent';
export default createReactComponent('ice-cream-2', 'IconIceCream2', [
  ['path', { d: 'M17.657 11a6 6 0 1 0 -11.315 0', key: 'svg-0' }],
  ['path', { d: 'M6.342 11l5.658 11l5.657 -11z', key: 'svg-1' }],
]);
